import dayjs from 'dayjs';
import { dateUtils } from '../../shared/lib';

const getDates = (departureDates: Array<string>) => {
  return departureDates.length === 1
    ? [departureDates[0]]
    : [departureDates[0], departureDates[1]];
};

export const getDatesText = (departureDates: Array<string>) => {
  const dates = getDates(departureDates);
  const toDate = dayjs(dates[0]);

  if (dates.length === 1) {
    return `${dateUtils.format(toDate, 'D MMMM')}`;
  }

  const fromDate = dayjs(dates[1]);

  return toDate.isSame(fromDate, 'month')
    ? `${dateUtils.format(toDate, 'D')} - ${dateUtils.format(
        fromDate,
        'D MMMM',
      )}`
    : `${dateUtils.format(toDate, 'D MMMM')} - ${dateUtils.format(
        fromDate,
        'D MMMM',
      )}`;
};
